import { render, staticRenderFns } from "./MeusCursos.vue?vue&type=template&id=264afd50&"
import script from "./MeusCursos.vue?vue&type=script&lang=js&"
export * from "./MeusCursos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports